import React, { useState } from "react";
import dayjs from "dayjs";
import { Autocomplete, Button, Grid, TextField } from "@mui/material";
import RegulatoryImg from "../../../images/Regulatory_report.svg";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Loader from "../../utils/Loader/Loader";
import axios from "axios";
import Swal from "sweetalert2";
import SecureLS from "secure-ls";
import {encrypt} from "../../../utils/cipher.js";
import { Route, Routes, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import reportStyle from "../DailyReports/DailyReport.module.css"


const WeeklyReport = () => {
  var ls = new SecureLS();

  const [reportName, setReportName] = useState("");
  const [reportDate, setReportDate] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [reportValue, setReportValue] = useState("");
  const [selectedDate, setSelectedDate] = useState(null)
  const [weeklyReports, setWeeklyReports] = useState(null);
  const [reportMap, setReportMap] = useState(null);
  const token = ls.get("token");  
  const weekday = ["sunday","monday","tuesday","wednesday","thursday","friday","saturday"];
  useEffect(() => {
    console.log("inside useeffect");
    let DR = [];

    let reportPayload = {
      frequency: "weekly",
      token: token,
    };
    console.log("get report payload", reportPayload);
    let encryptedPayload = encrypt(reportPayload);

    axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/getReportList`, {
        payload: encryptedPayload,
      })
      .then((res) => {
        let listMap={};
        console.log("res from getreport", res.data.list);
        if (res.data.success) {
          res.data.list.map((x, ind) => {
            DR.push({ case: `${ind + 1}`, label: x.reportName });
            listMap[x.reportName]=x.day;
          });
          }
          setWeeklyReports(DR); setReportMap(listMap);
        console.log("list", listMap);
      })
      .catch((errReport) => {
        console.log("errReport", errReport);
      });
  }, []);

  const navigate = useNavigate();

  const weeklyPayload = {
    reportDetails: {
      reportName: reportName,
      reportDate: reportDate,
    },
    reportCategory: "STATIC",
    token: token
  };
  useEffect(() => {
    setReportDate("")
  }, [reportName])
  let encryptedPayload = encrypt(weeklyPayload);
  const weeklyDownload = () => {
    if (weeklyPayload?.reportDetails?.reportName == "" || weeklyPayload?.reportDetails?.reportDate == "") {
      Swal.fire({
        title: "Warning",
        text: "Please Select Report Name and Date",
        icon: "warning"
      })
    } else {
      setIsLoading(true);
      axios.post(`${process.env.REACT_APP_BACKEND_URL}/createReport`, { payload: encryptedPayload }).then((res) => {
        console.log("res", res);
        if (res.data.url) {
          window.open(`${process.env.REACT_APP_BACKEND_URL}/reports/downloadfile?link=${res.data.url}`);
          setIsLoading(false);
          Swal.fire({
            title: "Success",
            text: "File downloaded successfully",
            icon: "success",
          })
        }
        else {
          Swal.fire({
            title: "Error",
            text: "File couldn't be Downloaded",
            icon: "error",
          })
          setIsLoading(false);
        }
      }).catch((err)=>{
        ls.clear();
        console.log("err", err)
        Swal.fire({
          title: "Error",
          text: "Session Expired",
          icon: "error",
        })
        navigate("/");
      })
    }
  };

  const isSunday = (date) => {
    return date.day() !== 0;
  };

  const isMonday = (date) => {
    return date.day() !== 1;
  };
  const isSaturday = (date) => {
    return date.day() !== 6;
  };


  return (
    <>
      <div className={reportStyle.Daily}>
        <p style={{ margin: "0 0 0 2rem", fontFamily: "Montserrat" }}>Weekly Report</p>

        <div className={reportStyle.dailyReportsDiv} id={reportStyle.hi} style={{ marginLeft: "2rem" }}>
          <Grid item xs={0} sm={0} md={6} lg={6} style={{ display: "flex", justifyContent: "center" }}>
            <img className="regImg" src={RegulatoryImg} alt="" style={{ margin: "3rem 0rem" }} />
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6} className={reportStyle.dailyReportsContent}>
            <Autocomplete
              className={reportStyle.dailyReports}
              id="disable-clearable"
              disableClearable
              sx={{
                "& .MuiAutocomplete-input, & .MuiInputLabel-root": {
                  fontSize: "1rem",
                  fontFamily: "Poppins, sans-serif",
                  fontWeight: "600",
                  textDecoration: "none",
                  paddingLeft: "2px",
                  color: "#1D1C3E",
                },
              }}
              options={weeklyReports}
              // getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(option, value) => option.value === value.value}
              onChange={(event, selectedOption) => {
                setReportName(selectedOption.label);
                setReportValue(selectedOption.value);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Report"
                  variant="standard"
                />
              )}
            />
            <LocalizationProvider
              // className={dailyReports.dailyCalendar}
              dateAdapter={AdapterDayjs}
            >
              <DemoContainer components={["DatePicker", "DesktopDatePicker"]}>
                <DesktopDatePicker
                  className={reportStyle.dailyDate}
                  value={reportDate}
                  onChange={(date) => {
                    if (date) {
                      // setSelectedDate(date)
                      const formattedDate = date.format("YYYY-MM-DD"); // Get YYYY-MM-DD part
                      setReportDate(formattedDate);
                    }
                  }}
                  shouldDisableDate = {(date)=>{
                    let day=reportMap[reportName];
                    let ind=weekday.indexOf(day);
                    return date.day() !== ind;
                  }}
                  disableFuture
                  format="YYYY-MM-DD"
                  slotProps={{
                    layout: {
                      sx: {
                        ".MuiDateCalendar-root": {
                          color: "#1D1C3E",
                          // width:"80%",

                        },
                      },
                    },
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>

            <Button
              className={reportStyle.dailyDownload}
              variant='outlined'
              onClick={weeklyDownload}
              disabled={isLoading}
              sx={{ color: `${isLoading ? "#000 !important" : "#1D1C3E"}` }}
            >
              {isLoading ? "Downloading..." : "Download"}
              {isLoading && <Loader color="#1D1C3E" />}
            </Button>
          </Grid>
        </div>
      </div>
    </>
  );
};

export default WeeklyReport;